<template lang='pug'>
  .modal-dialog.promo-code-description(role='document' v-if='promoCodeAttrs')
    .modal-content
      .modal-header
        span(v-if='requestFromCarousel() || requestFromListingPage()')
          .svg-icon.chevron-left.icon-sm.close(aria-label='Close' data-dismiss='modal')
        span(v-else)
          .svg-icon.chevron-left.icon-sm(@click='clearPromocodeDetails')
        h3.modal-title(v-t='"promoCodeDetailsTitle"')

      .modal-body.bg_white
        img.product-img(:src='promoCodeAttrs["details-image-url"]')
        b.promo-title.p-10(v-text='promoCodeAttrs["details-title"]')

        .code-section(:class='getTargetClass()')
          .p-10(v-t='"useCode"' v-if='!promoCodeAttrs["auto-apply"]').m-10
          .p-10
            CopyPromoCode(
              :promoCodeText='promoCodeAttrs.code'
              :isAutoApply='promoCodeAttrs["auto-apply"]'
              :cardSequenceNumber='promoCodeAttrs["card-sequence-number"]'
              parentContainer='viewPromoCodeDetails'
            )
          .p-10.how-to-apply-title(v-t='"howToApply"' v-if='!promoCodeAttrs["auto-apply"]')
          .p-10(v-t='"instruction"' v-if='!promoCodeAttrs["auto-apply"]')

        .p-10.promo-description(v-html='promoCodeAttrs["details-description"]')
        p.t-n-c(v-text='`${$t("common.termsAndConditions")}:`')
        .promo-t-n-c(v-html='promoCodeAttrs["details-terms-and-conditions"]')
      <template v-if='isBrowseProductsButtonOnDetailsEnabled'>
        BrowseProductsButton(
          :promoCodeAttrs='promoCodeAttrs'
        )
      </template>

</template>

<i18n>
{
  "lng_en": {
    "promoCodeDetailsTitle": "PROMO DETAILS",
    "useCode": "Use code:",
    "howToApply": "How to apply code:",
    "instruction": "Copy and apply the promo code on the shopping bag."
  },
  "lng_zh": {
    "promoCodeDetailsTitle": "優惠詳情",
    "useCode": "使用編碼：",
    "howToApply": "如何使用編碼：",
    "instruction": "複製編碼並將其應用在購物袋上。"
  },
  "lng_th": {
    "promoCodeDetailsTitle": "รายละเอียดโปรโมชั่น",
    "useCode": "ใช้รหัส:",
    "howToApply": "วิธีการใช้รหัส:",
    "instruction": "คัดลอกและใช้รหัสโปรโมชั่นบนถุงช้อปปิ้ง"
  },
  "lng_id": {
    "promoCodeDetailsTitle": "DETAIL PROMO",
    "useCode": "Gunakan kode:",
    "howToApply": "Cara menerapkan kode:",
    "instruction": "Salin dan terapkan kode promo pada tas belanja."
  },
  "lng_ko": {
    "promoCodeDetailsTitle": "프로모션 세부정보",
    "useCode": "코드 사용:",
    "howToApply": "코드 적용 방법:",
    "instruction": "쇼핑백에 있는 프로모션 코드를 복사하여 적용하세요."
  }
}
</i18n>

<script>
import CopyPromoCode from '@/components/shared/promo-code/copy-promo-code'
import BrowseProductsButton from '@/components/offers/browse-products-button'
import { mapState } from 'vuex'
import { promoCodeMixin } from '@/mixins/promo-code-mixin'

export default {
  mixins: [
    promoCodeMixin
  ],
  components: {
    CopyPromoCode,
    BrowseProductsButton
  },
  props: {
    targetContainer: {
      type: String,
      default: 'list'
    },
    promoCodeAttrs: {
      type: Object,
      default: null
    },
    browseProductsLink: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser
    }),
    isBrowseProductsButtonOnDetailsEnabled () {
      return this.browseProductsButtonEnabled
    }
  },
  methods: {
    requestFromCarousel () {
      return (this.targetContainer === 'carousel')
    },
    requestFromListingPage () {
      return (this.targetContainer === 'listing-page')
    },
    getTargetClass () {
      switch (this.targetContainer) {
        case 'carousel':
          return 'carousel-style'
        case 'list':
          return 'list-style'
        case 'listing-page':
          return 'listing-page-style'
      }
    },
    clearPromocodeDetails () {
      this.$emit('promoCodeDetailsPageClosed')
    }
  }
}
</script>
<style lang='scss' scoped>
  .modal-content {
    .modal-header {
      background: $black;
      align-items: center;

      .modal-title {
        color: $white;
        margin: 0 auto;
      }

      .svg-icon.chevron-left {
        cursor: pointer;
        display: block;
        background-image: url('../../assets/images/icons/chevron-left-white.svg');
        position: fixed;
        left: 1px;
        margin-top: -10px;

        @media (min-width: 768px) {
          left: 67px;
        }
      }
      .icon-sm {
        height: 23px;
      }
    }
    .modal-body {
      padding-top: 15px;
      overflow-y: auto;
      overflow-wrap: break-word;

      .code-section.list-style {
        display: none;
      }

      .product-img {
        width: 100%;
        margin-bottom: 10px;
      }

      .promo-title {
        font-size: 16px;
        text-transform: uppercase;
      }

      .p-10{
        padding-top: 10px;
        padding-bottom: 10px;
      }

      .m-10 {
        margin-bottom: -10px;
      }

      .how-to-apply-title {
        @include font-weight-bold;
        text-transform: capitalize;
      }

      .promo-description {
        border-bottom: 1px solid $grey;
      }
      .t-n-c {
        margin-top: 20px;
      }
    }
  }
  // for tablet devices and up
  @media (min-width: 768px) {
    .modal-dialog {
      height: 90%;
      align-items: center;

      .modal-content {
        width: 464px;
        height: 90%;
      }
      .modal-body {
        height: calc(100% - 60px);
      }
    }
  }

  // for mobile devices
  @media (max-width: 767px) {
    .modal-dialog {
      width: 100%;
      height: 100%;
      margin: 0;
      transform: none;
      .modal-content {
        height: 100%;
        .modal-body {
          height: 90%;
        }
        .browse-products-btn {
          width: 100%;
          position: fixed;
          bottom: 0;
          min-height: 48px;
        }
      }
    }
  }
</style>

// Not using scoped flag as it is dynamic html inside a v-html inside that scoped css is not working
<style lang='scss'>
  // to reset default application css for html rendered under v-html
  .promo-code-description {
    .promo-description, .promo-t-n-c {
      ol, ul{
        padding-left: 15px;
      }

      strong, em {
        font: revert;
      }

      li {
        list-style: inherit;
      }
    }
    .browse-products-btn {
      padding: 12px;
      font-weight: bold;
      background-color: $black;
      color: $white;
      display: block;
      cursor: pointer;
      text-align: center;
    }
  }
</style>
